import React, {useState} from "react";
import {Fab} from "@material-ui/core";
import SpacecastModal from "./SpacecastModal";
import {SpacecastIcon} from "../../../../../helpers/Icons";

export default function SpacecastStats({ spacecastData, setSpacecastData, spacecastArray }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div style={{margin:"1rem"}}>
      <Fab onClick={() => setIsOpen(true)} style={{zIndex:1}}>
        <SpacecastIcon />
      </Fab>
      <SpacecastModal
        isOpen={isOpen}
        close={() => setIsOpen(false)}
        spacecastData={spacecastData}
        setSpacecastData={setSpacecastData}
        spacecastArray={spacecastArray}
      />
    </div>
  );
}
